import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { DashboardService } from '../dashboard/dashboard.service';
import { BehaviorSubject } from 'rxjs';
import { LastRace } from './lastrace';


@Component({
  selector: 'app-adventure',
  templateUrl: './adventure.component.html',
  styleUrls: ['./adventure.component.css']
})
export class AdventureComponent implements OnInit {
  maplerace;
  lastrace : any;
  private _lastrace = new BehaviorSubject<any>('');

  @Input() 
  set data(value){
    this._lastrace.next(value);
  };

  get data() {
    return this._lastrace.getValue();
  };
  
  constructor(private httpClient: HttpClient, private dashboardService : DashboardService) { }

  ngOnInit(): void {
    

    this._lastrace.subscribe(async() => {
                await this.getAdventure();
                this.lastrace = this.data;
                if(this.lastrace)
                  this.getLastRace();
            });

            
  }




  async getLastRace() {
    this.setProgressBar();
  }

  async getAdventure(){
    this.maplerace = await this.httpClient.get("../../assets/adventures/maplerace.json").toPromise();
  }

  setProgressBar(){
    let raceFound = false;
    for(let city in this.maplerace.citys){
      for(let race in this.maplerace.citys[city].races){

          

        if(this.lastrace.idRace._id == this.maplerace.citys[city].races[race]._id){
          this.maplerace.citys[city].races[race].progress = ((this.lastrace.distanceRan * 100) /  this.maplerace.citys[city].races[race].distance).toFixed(0);
          
          if(this.maplerace.citys[city].races[race].progress < 100)
            this.maplerace.citys[city].started = true;
          raceFound = true
        }

        if(!raceFound && this.lastrace || 
          this.maplerace.citys[city].races[race].progress == 100 && raceFound){
          if(this.maplerace.citys[city].nbRaceFinished)
            this.maplerace.citys[city].nbRaceFinished += 1;
          else
            this.maplerace.citys[city].nbRaceFinished = 1;


          this.maplerace.citys[city].races[race].progress = 100;
        }


        

      }
    }

  }

}
